export const convertValsToStrings = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key,
      value === null ? "" : String(value)
      // typeof value === "boolean" ? String(value) : value
    ])
  );
};
export const riskAssessmentItems = [
  { key: "RiskLevel", label: "Level of Risk:" },
  { key: "RiskFactors", label: "Risk Factors:" },
  { key: "ProtectiveFactors", label: "Protective Factors:" },
];

export const interventionCategories = {
    "Cognitive/Behavioral": [
      { key: "CognitiveChallenging", label: "Cognitive Challenging" },
      { key: "CognitiveReframing", label: "Cognitive Reframing" },
      { key: "CognitiveRefocusing", label: "Cognitive Refocusing" },
      { key: "CommunicationSkills", label: "Communication Skills" },
      { key: "DBT", label: "DBT" },
      { key: "PsychoEducation", label: "Psycho Education" },
      { key: "StructuredProblemSolving", label: "Structured Problem Solving" }
    ],
    "Emotional/Insight Based": [
      { key: "CrisisManagement", label: "Crisis Management" },
      { key: "ExplorationOfEmotions", label: "Exploration of Emotions" },
      { key: "ExplorationOfRelationshipPatterns", label: "Exploration of Relationship Patterns" },
      { key: "ExplorationOfCopingPatterns", label: "Exploration of Coping Patterns" },
      { key: "GuidedImagery", label: "Guided Imagery" },
      { key: "SymptomManagement", label: "Symptom Management" }
    ],
    "Supportive/Skill-Building": [
      { key: "EmotionalRegulationSkills", label: "Emotional Regulation Skills" },
      { key: "InteractiveFeedback", label: "Interactive Feedback" },
      { key: "InterpersonalResolutions", label: "Interpersonal Resolutions" },
      { key: "MindfulnessTraining", label: "Mindfulness Training" },
      { key: "RelaxationDeepBreathing", label: "Relaxation/Deep Breathing" },
      { key: "SupportiveReflection", label: "Supportive Reflection" }
    ],
    "Behavioral/Plan-Focused": [
      { key: "ComplianceIssues", label: "Compliance Issues" },
      { key: "PreventativeServices", label: "Preventative Services" },
      { key: "ReviewOfPlan", label: "Review of Plan" },
      { key: "RolePlayBehavioralRehearsal", label: "Role-Play/Behavioral Rehearsal" }
    ]
};

export const currentMentalStatusItems = [
    { key: "Orientation", label: "Orientation" },
    { key: "Insight", label: "Insight" },
    { key: "GeneralAppearance", label: "General Appearance" },
    { key: "JudgementAndImpulseControl", label: "Judgment/Impulse Control" },
    { key: "Dress", label: "Dress" },
    { key: "Memory", label: "Memory" },
    { key: "MotorActivity", label: "Motor Activity" },
    { key: "AttentionConcentration", label: "Attention/Concentration" },
    { key: "InterviewBehaviour", label: "Interview Behaviour" },
    { key: "ThoughtProcess", label: "Thought Process" },
    { key: "Speech", label: "Speech" },
    { key: "ThoughtContent", label: "Thought Content" },
    { key: "Mood", label: "Mood" },
    { key: "Perception", label: "Perception" },
    { key: "Affect", label: "Affect" },
    { key: "FunctionalStatus", label: "Functional Status" },
];
export const getNoteDisplaySettings = (data, providerId, noteType) => {
  console.log("encounterNotesDisplaySettinggetNoteDisplaySettings", (data
    ?.find(p => p.ProviderID === providerId)?.Children?.find(s => s.NoteType === noteType) || {}))
  return (data
    ?.find(p => p.ProviderID === providerId)?.Children?.find(s => s.NoteType === noteType) || {});
};
export const HPI_GROUPS = [
  {
    title: "Chronicity",
    items: [
      { key: "Ch_New", label: "New" },
      { key: "Ch_Recurrent", label: "Recurrent" },
      { key: "Ch_Chronic", label: "Chronic" },
      { key: "Ch_Other", label: "Other" },
    ],
  },

  {
    title: "Onset Date",
    items: [
      { key: "On_Today", label: "Today" },
      { key: "On_Yesterday", label: "Yesterday" },
      { key: "On_Last7Days", label: "Last 7 days" },
      { key: "On_OneToFourWeeks", label: "1–4 weeks ago" },
      { key: "On_MoreThanOneMonth", label: "More than 1 month ago" },
      { key: "On_MoreThanOneYear", label: "More than 1 year ago" },
    ],
  },

  {
    title: "Duration / Lasts For",
    items: [
      { key: "Dur_Seconds", label: "Seconds" },
      { key: "Dur_Minutes", label: "Minutes" },
      { key: "Dur_Hours", label: "Hours" },
      { key: "Dur_AllDay", label: "All day" },
      { key: "Dur_SeveralDays", label: "Several days" },
      { key: "Dur_Weeks", label: "Weeks" },
      { key: "Dur_Constant", label: "Constant" },
      { key: "Dur_Intermittent", label: "Intermittent" },
      { key: "Dur_Other", label: "Other" },
    ],
  },

  {
    title: "Frequency",
    items: [
      { key: "Freq_Constantly", label: "Constantly" },
      { key: "Freq_Daily", label: "Daily" },
      { key: "Freq_TwoToFourPerDay", label: "2–4 times/day" },
      { key: "Freq_EverySeveralDays", label: "Every several days" },
      { key: "Freq_Intermittently", label: "Intermittently" },
      { key: "Freq_Rarely", label: "Rarely" },
    ],
  },

  {
    title: "Trend / Progression",
    items: [
      { key: "Tr_Unchanged", label: "Unchanged" },
      { key: "Tr_Resolved", label: "Resolved" },
      { key: "Tr_GraduallyImproving", label: "Gradually improving" },
      { key: "Tr_RapidlyImproving", label: "Rapidly improving" },
      { key: "Tr_GraduallyWorsening", label: "Gradually worsening" },
      { key: "Tr_RapidlyWorsening", label: "Rapidly worsening" },
    ],
  },

  {
    title: "Pain Severity",
    items: [
      { key: "Ps_NoPain", label: "No pain" },
      { key: "Ps_Mild", label: "Mild" },
      { key: "Ps_Moderate", label: "Moderate" },
      { key: "Ps_Severe", label: "Severe" },
    ],
  },

  {
    title: "Pain numeric",
    items: [
      { key: "Pn_0", label: "0/10" },
      { key: "Pn_1", label: "1/10" },
      { key: "Pn_2", label: "2/10" },
      { key: "Pn_3", label: "3/10" },
      { key: "Pn_4", label: "4/10" },
      { key: "Pn_5", label: "5/10" },
      { key: "Pn_6", label: "6/10" },
      { key: "Pn_7", label: "7/10" },
      { key: "Pn_8", label: "8/10" },
      { key: "Pn_9", label: "9/10" },
      { key: "Pn_10", label: "10/10" },
    ],
  },

  {
    title: "Pain Quality",
    items: [
      { key: "Pq_Sharp", label: "Sharp" },
      { key: "Pq_Shooting", label: "Shooting" },
      { key: "Pq_Cramping", label: "Cramping" },
      { key: "Pq_Throbbing", label: "Throbbing" },
      { key: "Pq_Stabbing", label: "Stabbing" },
      { key: "Pq_Numbing", label: "Numbing" },
      { key: "Pq_Tingling", label: "Tingling" },
      { key: "Pq_Burning", label: "Burning" },
      { key: "Pq_Aching", label: "Aching" },
      { key: "Pq_Other", label: "Other" },
    ],
  },

  {
    title: "Radiates to",
    items: [
      { key: "Rad_DoesNotRadiate", label: "Does not radiate" },
      { key: "Rad_Shooting", label: "Shooting" },
      { key: "Rad_LeftKnee", label: "Left knee" },
      { key: "Rad_RightKnee", label: "Right knee" },
      { key: "Rad_LeftFoot", label: "Left foot" },
      { key: "Rad_RightFoot", label: "Right foot" },
      { key: "Rad_LeftThigh", label: "Left thigh" },
      { key: "Rad_RightThigh", label: "Right thigh" },
      { key: "Rad_Other", label: "Other" },
    ],
  },

  {
    title: "Pain Pattern",
    items: [
      { key: "Pat_WorseDuringDay", label: "Worse during day" },
      { key: "Pat_WorseDuringNight", label: "Worse during night" },
      { key: "Pat_SameAllTheTime", label: "Same all the time" },
    ],
  },

  {
    title: "Aggravated by",
    items: [
      { key: "Agg_Bending", label: "Bending" },
      { key: "Agg_PositionChange", label: "Position change" },
      { key: "Agg_Sitting", label: "Sitting" },
      { key: "Agg_Standing", label: "Standing" },
      { key: "Agg_Stress", label: "Stress" },
      { key: "Agg_Coughing", label: "Coughing" },
      { key: "Agg_Exertion", label: "Exertion" },
      { key: "Agg_Twisting", label: "Twisting" },
      { key: "Agg_Turning", label: "Turning" },
      { key: "Agg_Walking", label: "Walking" },
      { key: "Agg_DeepBreaths", label: "Deep breaths" },
      { key: "Agg_Nothing", label: "Nothing" },
      { key: "Agg_Other", label: "Other" },
    ],
  },

  {
    title: "Alleviating Factor",
    items: [
      { key: "Aliv_Nothing", label: "Nothing" },
      { key: "Aliv_ChiropracticTreatment", label: "Chiropractic treatment" },
      { key: "Aliv_Ice", label: "Ice" },
      { key: "Aliv_NSAIDs", label: "NSAIDs" },
      { key: "Aliv_Injections", label: "Injections" },
      { key: "Aliv_Heat", label: "Heat" },
      { key: "Aliv_MuscleRelaxant", label: "Muscle relaxant" },
      { key: "Aliv_Walking", label: "Walking" },
      { key: "Aliv_BedRest", label: "Bed rest" },
      { key: "Aliv_HomeExercises", label: "Home exercises" },
      { key: "Aliv_Supplements", label: "Supplements" },
      { key: "Aliv_Other", label: "Other" },
    ],
  },

  {
    title: "Associated Symptoms",
    items: [
      { key: "Sym_Fever", label: "Fever" },
      { key: "Sym_Headache", label: "Headache" },
      { key: "Sym_Weakness", label: "Weakness" },
      { key: "Sym_Numbness", label: "Numbness" },
      { key: "Sym_Tingling", label: "Tingling" },
      { key: "Sym_WeightLoss", label: "Weight loss" },
      { key: "Sym_ChestPain", label: "Chest pain" },
      { key: "Sym_Dysuria", label: "Dysuria" },
      { key: "Sym_LegPain", label: "Leg pain" },
      { key: "Sym_Other", label: "Other" },
    ],
  },

  {
    title: "Risk Factors",
    items: [
      { key: "Rf_HistoryOfCancer", label: "History of cancer" },
      { key: "Rf_Menopause", label: "Menopause" },
      { key: "Rf_Pregnancy", label: "Pregnancy" },
      { key: "Rf_HistoryOfOsteoporosis", label: "Osteoporosis" },
      { key: "Rf_Obesity", label: "Obesity" },
      { key: "Rf_RecentTrauma", label: "Recent trauma" },
      { key: "Rf_HistoryOfSteroidUse", label: "Steroid use" },
      { key: "Rf_PoorPosture", label: "Poor posture" },
      { key: "Rf_SedentaryLifestyle", label: "Sedentary lifestyle" },
      { key: "Rf_LackOfExercise", label: "Lack of exercise" },
      { key: "Rf_Other", label: "Other" },
    ],
  },

  {
    title: "Response to Treatment",
    items: [
      { key: "Resp_NoRelief", label: "No relief" },
      { key: "Resp_Mild", label: "Mild" },
      { key: "Resp_Moderate", label: "Moderate" },
      { key: "Resp_Significant", label: "Significant" },
    ],
  },

  {
    title: "Any bleeding",
    items: [
      { key: "Bleeding_Yes", label: "Yes" },
      { key: "Bleeding_No", label: "No" },
    ],
  },
];

export const ROS_GROUPS = [
  {
    title: "Constitution",
    items: [
      { key: "Con_ActivityChange", label: "Activity change" },
      { key: "Con_AppetiteChange", label: "Appetite change" },
      { key: "Con_Chills", label: "Chills" },
      { key: "Con_Diaphoresis", label: "Diaphoresis" },
      { key: "Con_Fatigue", label: "Fatigue" },
      { key: "Con_Fever", label: "Fever" },
      { key: "Con_UnexpectedWeightChange", label: "Unexpected weight change" },
    ],
  },

  {
    title: "Head",
    items: [
      { key: "Head_FacialSwelling", label: "Facial swelling" },
      { key: "Head_NeckPain", label: "Neck pain" },
      { key: "Head_NeckStiffness", label: "Neck stiffness" },
      { key: "Head_EarDischarge", label: "Ear discharge" },
      { key: "Head_HearingAid", label: "Hearing aid" },
      { key: "Head_ChangesInHearing", label: "Changes in hearing" },
      { key: "Head_EarPain", label: "Ear pain" },
      { key: "Head_Tinnitus", label: "Tinnitus" },
      { key: "Head_Nosebleeds", label: "Nosebleeds" },
      { key: "Head_Congestion", label: "Congestion" },
      { key: "Head_Rhinorrhea", label: "Rhinorrhea" },
      { key: "Head_PostnasalDrip", label: "Postnasal drip" },
      { key: "Head_Sneezing", label: "Sneezing" },
      { key: "Head_SinusPressure", label: "Sinus pressure" },
      { key: "Head_DentalProblem", label: "Dental problem" },
      { key: "Head_Drooling", label: "Drooling" },
      { key: "Head_MouthSores", label: "Mouth sores" },
      { key: "Head_SoreThroat", label: "Sore throat" },
      { key: "Head_TroubleSwallowing", label: "Trouble swallowing" },
      { key: "Head_VoiceChange", label: "Voice change" },
    ],
  },

  {
    title: "Eyes",
    items: [
      { key: "Eye_ContactLenses", label: "Contact lenses" },
      { key: "Eye_EyeDischarge", label: "Eye discharge" },
      { key: "Eye_EyeItching", label: "Eye itching" },
      { key: "Eye_EyePain", label: "Eye pain" },
      { key: "Eye_EyeRedness", label: "Eye redness" },
      { key: "Eye_Glasses", label: "Glasses" },
      { key: "Eye_Photophobia", label: "Photophobia" },
      { key: "Eye_UnexpectedVisionChange", label: "Unexpected vision change" },
    ],
  },

  {
    title: "Respiratory",
    items: [
      { key: "Resp_Apnea", label: "Apnea" },
      { key: "Resp_ChestTightness", label: "Chest tightness" },
      { key: "Resp_Choking", label: "Choking" },
      { key: "Resp_Cough", label: "Cough" },
      { key: "Resp_ShortnessOfBreath", label: "Shortness of breath" },
      { key: "Resp_Stridor", label: "Stridor" },
      { key: "Resp_Wheezing", label: "Wheezing" },
    ],
  },

  {
    title: "Cardiovascular",
    items: [
      { key: "Card_ChestPain", label: "Chest pain" },
      { key: "Card_LegSwelling", label: "Leg swelling" },
      { key: "Card_Palpitations", label: "Palpitations" },
    ],
  },

  {
    title: "GI",
    items: [
      { key: "Gi_AbdDistention", label: "Abdominal distention" },
      { key: "Gi_AbdominalPain", label: "Abdominal pain" },
      { key: "Gi_AnalBleeding", label: "Anal bleeding" },
      { key: "Gi_BloodInStool", label: "Blood in stool" },
      { key: "Gi_Constipation", label: "Constipation" },
      { key: "Gi_Diarrhea", label: "Diarrhea" },
      { key: "Gi_Heartburn", label: "Heartburn" },
      { key: "Gi_Nausea", label: "Nausea" },
      { key: "Gi_RectalPain", label: "Rectal pain" },
      { key: "Gi_Vomiting", label: "Vomiting" },
    ],
  },

  {
    title: "Endocrine",
    items: [
      { key: "Endo_ColdIntolerance", label: "Cold intolerance" },
      { key: "Endo_HeatIntolerance", label: "Heat intolerance" },
      { key: "Endo_HotFlashes", label: "Hot flashes" },
      { key: "Endo_Polydipsia", label: "Polydipsia" },
      { key: "Endo_Polyphagia", label: "Polyphagia" },
      { key: "Endo_Polyuria", label: "Polyuria" },
    ],
  },

  {
    title: "GU",
    items: [
      { key: "Gu_ProblemWithUrination", label: "Problem with urination" },
      { key: "Gu_Dysuria", label: "Dysuria" },
      { key: "Gu_ErectileDysfunction", label: "Erectile dysfunction" },
      { key: "Gu_FlankPain", label: "Flank pain" },
      { key: "Gu_Frequency", label: "Frequency" },
      { key: "Gu_GenitalSore", label: "Genital sore" },
      { key: "Gu_BloodInUrine", label: "Blood in urine" },
      { key: "Gu_Incontinence", label: "Incontinence" },
      { key: "Gu_Nocturia", label: "Nocturia" },
      { key: "Gu_PenileDischarge", label: "Penile discharge" },
      { key: "Gu_PenilePain", label: "Penile pain" },
      { key: "Gu_PenileSwelling", label: "Penile swelling" },
      { key: "Gu_ScrotalSwelling", label: "Scrotal swelling" },
      { key: "Gu_TesticularPain", label: "Testicular pain" },
      { key: "Gu_Urgency", label: "Urgency" },
      { key: "Gu_UrineDecreased", label: "Decreased urine" },
    ],
  },

  {
    title: "Musc",
    items: [
      { key: "Musc_JointPain", label: "Joint pain" },
      { key: "Musc_BackPain", label: "Back pain" },
      { key: "Musc_GaitProblem", label: "Gait problem" },
      { key: "Musc_JointSwelling", label: "Joint swelling" },
      { key: "Musc_Myalgias", label: "Myalgias" },
    ],
  },

  {
    title: "Skin",
    items: [
      { key: "Skin_ColorChange", label: "Color change" },
      { key: "Skin_Pallor", label: "Pallor" },
      { key: "Skin_PersistentRash", label: "Persistent rash" },
      { key: "Skin_Wound", label: "Wound" },
    ],
  },

  {
    title: "Allerg/Immuno",
    items: [
      { key: "Allerg_EnvironmentalAllergies", label: "Environmental allergies" },
      { key: "Allerg_FoodAllergies", label: "Food allergies" },
      { key: "Allerg_Immunocompromised", label: "Immunocompromised" },
    ],
  },

  {
    title: "Neurological",
    items: [
      { key: "Neuro_MemoryChanges", label: "Memory changes" },
      { key: "Neuro_Dizziness", label: "Dizziness" },
      { key: "Neuro_FacialAsymmetry", label: "Facial asymmetry" },
      { key: "Neuro_Headaches", label: "Headaches" },
      { key: "Neuro_LightHeadedness", label: "Light-headedness" },
      { key: "Neuro_Numbness", label: "Numbness" },
      { key: "Neuro_Seizures", label: "Seizures" },
      { key: "Neuro_SpeechDifficulty", label: "Speech difficulty" },
      { key: "Neuro_Syncope", label: "Syncope" },
      { key: "Neuro_Weakness", label: "Weakness" },
    ],
  },

  {
    title: "Hematologic",
    items: [
      { key: "Hem_Adenopathy", label: "Adenopathy" },
      { key: "Hem_BruisesEasily", label: "Bruises easily" },
    ],
  },

  {
    title: "Psychiatric",
    items: [
      { key: "Psych_Agitation", label: "Agitation" },
      { key: "Psych_BehaviorProblem", label: "Behavior problem" },
      { key: "Psych_Confusion", label: "Confusion" },
      { key: "Psych_DecreasedConcentration", label: "Decreased concentration" },
      { key: "Psych_DysphoricMood", label: "Dysphoric mood" },
      { key: "Psych_Hallucinations", label: "Hallucinations" },
      { key: "Psych_Hyperactive", label: "Hyperactive" },
      { key: "Psych_NervousAnxious", label: "Nervous / anxious" },
      { key: "Psych_SelfInjury", label: "Self injury" },
      { key: "Psych_SleepDisturbance", label: "Sleep disturbance" },
      { key: "Psych_SuicidalIdeas", label: "Suicidal ideas" },
    ],
  },
];

export const isSignedOrToBeCoSigned = ["Signed", "To Be Co-Signed"];